import { getText } from '@amzn/awscat-editor';
import {
  Content,
  ContentNode,
  ContentType,
  ValidationHelper,
} from '@amzn/awscat-pattern-library-service-model';

interface ErrorInfo {
  key: string;
  value: string;
}
export const validateAndUpdateLinksInContentData = (content: Content): ErrorInfo[] => {
  let validationError: ErrorInfo[] = [];
  validationError = validateAndUpdateLinksInContentNode(
    content.contentData,
    content.contentMetadata.contentType,
    validationError,
  );
  return validationError;
};

const validateAndUpdateLinksInContentNode = (
  contentNode: ContentNode,
  contentType: ContentType,
  validationError: ErrorInfo[],
) => {
  const { contentData, subContent, contentSections, nodeType, title: titleData } = contentNode;
  const title = getText(titleData);

  if (contentData) {
    try {
      validationError = validateAndUpdateLinks(
        contentData,
        `${nodeType}: ${title}`,
        validationError,
      );
    } catch (e) {
      validationError.push({
        key: 'Link validation error',
        value: `Unable to evaluate links ${e}`,
      });
    }
  }

  subContent?.forEach((content) =>
    validateAndUpdateLinksInContentNode(content, contentType, validationError),
  );
  contentSections?.forEach((section) =>
    validateAndUpdateLinksInContentNode(section, contentType, validationError),
  );

  return validationError;
};

const validateAndUpdateLinks = (
  contentData: any,
  linkInfo: string,
  validationError: ErrorInfo[],
) => {
  if (contentData?.content && Array.isArray(contentData.content)) {
    contentData?.content.forEach(
      // @ts-expect-error TS7006 - strict migration
      (content) =>
        (validationError =
          validateAndUpdateLinks(content, linkInfo, validationError) ?? validationError),
    );
  } else if (contentData?.marks && Array.isArray(contentData.marks)) {
    contentData?.marks.forEach(
      // @ts-expect-error TS7006 - strict migration
      (mark) =>
        (validationError =
          validateAndUpdateLinks(
            mark,
            `${linkInfo}, Link text: ${contentData.text}`,
            validationError,
          ) ?? validationError),
    );
  } else if (contentData?.type === 'link') {
    const linkData = contentData?.attrs;
    linkData.href = linkData.href.trim();
    linkData.rel = 'noopener noreferrer nofollow';
    if (linkData.href.toLowerCase().startsWith('http://')) {
      linkData.href = linkData.href.replace(/http:\/\//i, 'https://');
    }
    if (!ValidationHelper.isValidContentLink(linkData.href)) {
      validationError.push({ key: `Invalid link: ${linkData.href}`, value: linkInfo });
    }
  }
  return validationError;
};
